module.exports = __webpack_public_path__ + "img/code2.9fcb9571.jpg";